var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            dense: "",
                            "error-messages": _vm.errors.initials,
                            label: "Sigla*",
                          },
                          model: {
                            value: _vm.model.initials,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "initials", $$v)
                            },
                            expression: "model.initials",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("sys-select-company", {
                          attrs: {
                            model: _vm.model.company_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.company_id,
                            label: "Empresa",
                            clearable: "",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "company_id", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("sys-select-payment-type", {
                          attrs: {
                            model: _vm.model.paymentTypes,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.paymentTypes,
                            label: "Tipo de Pagamento",
                            multiple: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "paymentTypes", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-switch", {
                          attrs: { inset: "", label: "Padrão" },
                          model: {
                            value: _vm.model.default,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "default", $$v)
                            },
                            expression: "model.default",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-switch", {
                          attrs: { color: "purple", inset: "", label: "Ativo" },
                          model: {
                            value: _vm.model.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "active", $$v)
                            },
                            expression: "model.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }